import React from 'react'
import List from './List'
import { useDistributionSubcategoryCreatedUpdatedById } from 'src/queries'

interface BodyProps {
  id: string
}

const Body: React.FC<BodyProps> = (props) => {
  const { id } = props
  const distributionSubcategory = useDistributionSubcategoryCreatedUpdatedById(id)
  return (
    <List distributionSubcategory={distributionSubcategory} />
  )
}

export default Body
